export const SPRITE_VERSION = '23b06'
